module.exports = __webpack_public_path__ + "img/guide08.bcf0d1b1.png";